import { render, staticRenderFns } from "./Chapter.vue?vue&type=template&id=42e3b227&scoped=true"
import script from "./Chapter.vue?vue&type=script&lang=js"
export * from "./Chapter.vue?vue&type=script&lang=js"
import style0 from "./Chapter.vue?vue&type=style&index=0&id=42e3b227&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e3b227",
  null
  
)

export default component.exports